import * as React from 'react';
import * as _ from 'lodash';
import { RadioList } from '../Generic/radioList';
import DropDown from '../Generic/dropDown2';
export default function () {
    function onSelect1(value, values) {
        this.handleOption(value, values);
    }
    function onClick2() {
        this.setState({ showFabricatorDDL: true });
    }
    function onClickOutside3() {
        this.setState({ showFabricatorDDL: false });
    }
    function onSelect4(val) {
        this.setState({
            showFabricatorDDL: false,
            selectedFabricator: val
        });
    }
    return React.createElement('div', { 'className': 'import-overlay-popup' }, React.createElement('div', { 'className': 'import-overlay-popup-header' }, React.createElement('div', { 'className': 'import-overlay-popup-header--title' }, '\r\n      Import Fabricators and Zip Codes\r\n    '), React.createElement('div', { 'className': 'import-overlay-popup-header--control' }, React.createElement('div', { 'className': 'import-overlay-popup-header--control-close' }))), React.createElement('div', { 'className': 'import-overlay-popup-body' }, this.state.importing ? React.createElement('div', {
        'style': {
            width: '100%',
            height: '100%',
            margin: '0',
            padding: '0',
            position: 'absolute',
            zIndex: '2000'
        },
        'key': '524'
    }, React.createElement('div', { 'className': 'ui-loader' })) : null, React.createElement('input', {
        'type': 'file',
        'ref': node => this.fileUploadRef = node,
        'accept': '.csv, .zip'
    }), React.createElement(RadioList, {
        'items': this.getFabricatorOptions(),
        'onSelect': onSelect1.bind(this),
        'multiple': false
    }), this.state.cloneFabricator ? React.createElement('div', {
        'className': 'fc-inst__select select2 ' + (this.state.showFabricatorDDL ? 'select2--active' : ''),
        'key': '1013'
    }, React.createElement('div', {
        'className': 'select2-value',
        'onClick': onClick2.bind(this)
    }, this.getSelectedText()), React.createElement(DropDown, {
        'selected': this.state.selectedFabricator,
        'items': this.state.fabricators,
        'onClickOutside': onClickOutside3.bind(this),
        'onSelect': onSelect4.bind(this)
    })) : null), React.createElement('div', { 'className': 'import-overlay-popup-footer' }, React.createElement('div', { 'className': 'ui-popup-footer__right' }, React.createElement('button', {
        'className': 'ui-button ui-button--red',
        'onClick': this.handleCancel
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')), React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': this.handleImport
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Import')))));
}